import { Directive, HostListener, input, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs';
import { coerceNumberProperty, NumberInput } from '@angular/cdk/coercion';

@Directive({
  selector: '[softHasFocus]',
  exportAs: 'softHasFocus',
  standalone: true,
})
export class HasFocusDirective {
  readonly _hasFocus = signal(false);

  readonly debounceTime = input<number, NumberInput>(120, {
    alias: 'softHasFocusDebounceTime',
    transform: coerceNumberProperty,
  });

  get hasFocus(): boolean {
    return this._hasFocus();
  }

  readonly hasFocusDebounced = toSignal(
    toObservable(this._hasFocus).pipe(debounceTime(this.debounceTime() ?? 0))
  );

  constructor() {}

  @HostListener('focus', ['$event']) onFocus(e: FocusEvent): void {
    this._hasFocus.set(true);
  }
  @HostListener('blur', ['$event']) onBlur(e: FocusEvent): void {
    this._hasFocus.set(false);
  }
}
